<template>
  <div class="passwordPage">
    <div class="head_wrapper flex-rowl">
      <i class="iconfont icon-xingmingyonghumingnicheng"></i>
      <div class="cont">
        <p>用户注册</p>
        <p>成为Wink SShoWP SPR注册用户</p>
      </div>
    </div>
    <div class="from_wrapper" v-if="step == 1">
      <div class="from">
        <div class="input_box">
          <span class="mark">*</span>
          <van-field v-model="tel" placeholder="请输入手机号" />
        </div>
        <div class="input_box vifity_code flex-between">
          <span class="mark">*</span>
          <van-field v-model="code" placeholder="输入短信验证码" />
          <div
            class="vifity_btn flex-rowc"
            :class="{ disable: isDisable }"
            @click="handleSendVifity"
          >
            {{ countText }}
          </div>
        </div>
        <div class="input_box">
          <span class="mark">*</span>
          <van-field
            v-model="pwd"
            :type="pwdType"
            maxlength="18"
            placeholder="请输入密码（6~18位英文加数字，区分大小写）"
          />
          <div class="visual" @click="handleVisualPwd(1)">
            <i
              class="iconfont"
              :class="
                pwdType == 'password' ? 'icon-icon_xianshi' : 'icon-xianshi'
              "
            ></i>
          </div>
        </div>
        <div class="input_box">
          <span class="mark">*</span>
          <van-field
            v-model="pwd2"
            :type="pwd1Type"
            maxlength="18"
            placeholder="请再次输入密码，请确保与首次输入的密码保持一致"
          />
          <div class="visual" @click="handleVisualPwd(2)">
            <i
              class="iconfont"
              :class="
                pwd1Type == 'password' ? 'icon-icon_xianshi' : 'icon-xianshi'
              "
            ></i>
          </div>
        </div>
        <div class="agree_wrapper flex-rowl">
          <van-checkbox
            v-model="checked"
            shape="square"
            checked-color="#F62560"
            class="check"
          />
          <div class="txt">
            <p>你已阅读并充分理解，WINK SShoWP SPR的</p>
            <agree></agree>
            <p>
              确认同意，允许WINK SShoWP在相关服务流程中，
              对你的个人信息进行收集和使用
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="from_wrapper" v-else-if="step == 2">
      <div class="tit flex-between">
        <div class="left flex-rowl">
          <div class="icon flex-rowc">
            <van-image
              width="100%"
              height="100%"
              :src="require('../assets/images/user_icon.png')"
            />
          </div>
          <div class="cont">
            <p>用户注册</p>
            <p>成为Wink SShoWP SPR注册用户</p>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="icon flex-rowc">
          <van-image
            width="100%"
            height="100%"
            :src="require('../assets/images/success_icon.png')"
          />
        </div>
        <p>注册成功</p>
      </div>
    </div>

    <div v-if="step == 1">
      <div class="custom_btn next btn" @click="handleNextOne">确认 <i class="iconfont icon-yuyinjiantou"></i></div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <div v-else-if="step == 2">
      <div class="custom_btn btn" @click="handleReturn">返回首页</div>
    </div>

    <van-overlay :show="isShow" @click="isShow = false"> </van-overlay>
    <div class="popup_box" v-if="isShow" @click.self="isShow = false">
      <div class="popup_wrapper">
        <div class="popup_header flex-between">
          <div class="tit">请完成安全验证</div>
          <van-icon name="cross" @click="isShow = false" />
        </div>
        <div class="popup_content flex-rowc">
          <div class="verify-wrap">
            <Verify
              :type="3"
              :barSize="barSize"
              :showButton="false"
              @success="successVerify"
              @error="erroeVerify"
            ></Verify>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sendVerfity, register } from "../api/api";
import Verify from "vue2-verify";
import agree from "../components/Agreement.vue";
export default {
  name: "passwordFind",
  components: { Verify, agree },
  data() {
    return {
      step: 1,
      pwdType: "password",
      pwd1Type: "password",
      isDisable: false,
      countText: "获取验证码",
      tel: "",
      code: "",
      pwd: "",
      pwd2: "",
      isShow: false,
      checked: false,

      barSize: {
        width: "100%",
        height: "40px",
      },
      isVerify: false, // 是否验证成功
      token: "",
    };
  },
  methods: {
    // 密码显示
    handleVisualPwd(type) {
      if (type == 1) {
        this.pwdType = this.pwdType == "password" ? "text" : "password";
      } else if (type == 2) {
        this.pwd1Type = this.pwd1Type == "password" ? "text" : "password";
      }
    },
    // 拖动滑块成功
    successVerify(obj) {
      this.isVerify = true;
      this.code = "";
      this.verfity(obj);
    },
    // 拖动滑块失败
    erroeVerify(obj) {
      this.verify = false;
      this.code = "";
      obj.refresh();
    },

    // 返回上一页
    handleReturn() {
      this.$router.back();
    },

    // 验证码
    handleSendVifity() {
      let { tel, isDisable, isVerify } = this;
      if (isDisable) return;
      let photoReg = /^1[3-9]\d{9}$/;
      if (tel == "") {
        this.$toast("请输入手机号！");
        return;
      } else if (!photoReg.test(tel)) {
        this.$toast("请输入正确的手机号！");
        return;
      }
      if (!isVerify) {
        // this.$toast("请向右滑完成验证");
        this.isShow = true;
        return;
      }
    },
    // 发送验证码
    verfity(obj) {
      let params = {
        cellphone: this.tel,
        screen: "比鹏鸟生活服务用户注册",   // 5-维应生活服务开发版用户注册、2005-维应生活服务用户注册、2005-比鹏鸟生活服务用户注册
        // screen: "富士康送餐用户注册",
      };
      // 关闭验证弹窗 start
      obj.refresh();
      this.isVerify = false;
      this.isShow = false;
      // 关闭验证弹窗 end
      const Toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "发送中，请稍后...",
      });
      let i = 60;
      sendVerfity(params)
        .then((res) => {
          if (res.result) {
            // this.isShow = false;
            const timer = setInterval(() => {
              i--;
              if (i <= 0) {
                this.countText = `重发验证码`;
                this.isDisable = false;
                clearInterval(timer);
              } else {
                this.countText = `重发验证码（${i--}）s`;
                this.isDisable = true;
              }
            }, 1000);
            // this.$toast.success(res.msg);
          } else {
            this.$toast.fail(res.msg || '服务器报错，请稍后～');
          }
          Toast.clear()
          // 重置滑块
          // setTimeout(() => {

          // }, 500);
        })
        .catch((err) => {
          Toast.clear()
          this.$toast.fail(err.mess || '服务器报错，请稍后～');
          // obj.refresh();
          // this.isVerify = false;
          // this.isShow = false
        });
    },

    // 提交
    handleNextOne() {
      let { tel, code, pwd, pwd2, checked } = this;
      let photoReg = /^1[3-9]\d{9}$/;
      if (tel == "") {
        this.$toast("请输入手机号");
        return;
      } else if (!photoReg.test(tel)) {
        this.$toast("请输入正确的手机号！");
        return;
      }
      if (code == "") {
        this.$toast("请输入验证码");
        return;
      }
      if (pwd == "" || pwd2 == "") {
        this.$toast("请输入密码");
        return;
      }
      if (pwd2 != pwd) {
        this.$toast("密码不一致，请重新输入密码");
        return;
      }
      if (pwd.length < 6 || pwd2.length < 6) {
        this.$toast("请输入最少6位数密码");
        return;
      }
      if (!checked) {
        this.$toast("请阅读用户条款和隐私政策");
        return;
      }
      let params = {
        usertype: 1,
        loginname: "",
        mobile: tel,
        code,
        loginpwd: pwd,
        loginpwd2: pwd2,
      };
      register(params).then((res) => {
        if (res.result) {
          this.step = 2;
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.passwordPage {
  background: hsl(0, 0%, 98%);
  height: 100vh;
  box-sizing: border-box;
  .head_wrapper {
    padding: 156px 0 38px 83px;
    .iconfont {
      font-size: 40px;
    }
    .cont {
      margin-left: 24px;
      font-size: 30px;
      color: #333333;
      p {
        &:last-child {
          font-size: 20px;
          margin-top: 7px;
        }
      }
    }
  }
  .from_wrapper {
    background: #fff;
    padding: 60px 75px 100px;
    .tit {
      font-size: 24px;
      color: #333333;
      margin-bottom: 60px;
      .icon {
        width: 35px;
        height: 39px;
        margin-right: 24px;
      }
    }
    .from {
      .input_box {
        background: #f0f0f0;
        position: relative;
        border: none;
        margin-bottom: 30px;
        padding: 0 70px 0 33px;
        font-size: 20px;
        .mark {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -25px;
          font-size: 35px;
          color: #F62560;
        }
        &.vifity_code {
          padding-right: 2px;
          .vifity_btn {
            height: 95%;
            background: #fff;
            font-size: 20px;
            color: #373737;
            border-radius: 45px;
            white-space: nowrap;
            padding: 0 30px;
            &.disable {
              background: #ccc;
            }
          }
        }
        .visual {
          position: absolute;
          top: 50%;
          right: 30px;
          transform: translateY(-50%);
          .iconfont {
            font-size: 38px;
            color: #818181;
          }
        }
      }
    }
    .content {
      font-size: 30px;
      color: #333333;
      text-align: center;
      padding: 106px 0;
      .icon {
        width: 75px;
        height: 75px;
        margin: 0 auto 48px;
      }
    }
  }
  .btn {
    margin: 90px auto 73px;
  }
  .return_txt {
    font-size: 24px;
    color: #373737;
    text-align: center;
  }
  .agree_wrapper {
    padding: 40px 20px 0;
    font-size: 20px;
    color: #1e1e1e;
    align-items: flex-start;
    .check {
      margin-right: 15px;
      flex-shrink: 0;
    }
    .txt {
      p {
        line-height: 30px;
        &:last-child {
          margin-top: 20px;
        }
      }
    }
  }
  .verify-wrap {
    width: 500px;
    font-size: 20px;
  }
  .popup_box {
    height: 100vh;
    top: 0;
    position: fixed;
    z-index: 999999999999;
    width: 100%;
    .popup_wrapper {
      width: 550px;
      box-sizing: border-box;
      background: #fff;
      top: 34%;
      margin: auto;
      position: relative;
      z-index: 9999999999;
      .popup_header {
        height: 110px;
        padding: 0 20px;
        font-size: 32px;
        box-sizing: border-box;
      }
      .popup_content {
        padding: 25px 0 70px;
        position: relative;
      }
    }
  }
}
</style>